/**
 * @file
 * RCC data layer JS.
 */

(function ($, Drupal, datalayer, debounce, once) {
  Drupal.behaviors.rcc_data_layer = {
    attach: function (context) {
      var _this = this;

      Object.keys(_this.dataLayerEventHandlers).forEach(function (eventName) {
        _this.dataLayerEventHandlers[eventName](context);
      });
    },

    /**
     * Data layer event handlers.
     */
    dataLayerEventHandlers: {

      /**
       * Exposed Primary Navigation Links event.
       */
      exposedPrimaryNavigationLinks: function (context) {
        var $mainMenu = $('.main-menu', context),
            $mainMenuParentItem = $('.menu-item.has-dropdown > a', $mainMenu);

        $mainMenuParentItem.each(function () {
          $(this).on('mouseenter', function () {
            var nameOfDropdown = $(this).text();

            datalayer.push({
              'event': 'Navigation',
              'eventCategory': 'Navigation',
              'eventAction': 'Exposed Primary Navigation Links',
              'eventLabel': `Exposed Section: ${nameOfDropdown}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'exposedSection': nameOfDropdown,
              }
            });
          });
        });
      },

      /**
       * Followed Related Site Link event.
       */
      relatedSiteLink: function (context) {
        var $selectSiteMenu = $('.menu--select-site-menu .menu .menu', context),
            $selectSiteMenuItem = $('.menu-item > a', $selectSiteMenu);

        $selectSiteMenuItem.each(function () {
          $(this).on('click', function (e) {
            var textUserClickedOn = $(this).text(),
                destinationURL = e.target.href;

            datalayer.push({
              'event': 'Navigation',
              'eventCategory': 'Navigation',
              'eventAction': 'Followed Related Site Link',
              'eventLabel': `Related Site Link Followed: ${textUserClickedOn} | Link URL: ${destinationURL}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'navigationText': textUserClickedOn,
                'urlNavigatedTo': destinationURL
              }
            });
          });
        });
      },

      /**
       * Followed Navigation Link event.
       */
      followedNavigationLink: function (context) {
        var $mainMenu = $('.main-menu', context),
            $mainMenuItem = $('.menu-item a[href]', $mainMenu);

        $mainMenuItem.each(function () {
          $(this).on('click', function (e) {
            var textUserClickedOn = $(this).text(),
                destinationURL = e.target.href;

            datalayer.push({
              'event': 'Navigation',
              'eventCategory': 'Navigation',
              'eventAction': 'Followed Link',
              'eventLabel': `Link Text: ${textUserClickedOn} | Link URL: ${destinationURL}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'navigationText': textUserClickedOn,
                'urlNavigatedTo': destinationURL
              }
            });
          });
        });
      },

      /**
       * Clicked a Social Icon event.
       */
      clickedSocialIcon: function (context) {
        var $socialShareBlock = $('.block-social-sharing-block', context),
            $socialShareItem = $('a.share', $socialShareBlock);

        $socialShareItem.each(function () {
          $(this).on('click', function (e) {
            var socialNetwork = $(this).attr('title'),
                socialTarget = e.target.href;

            datalayer.push({
              'event': 'Social Interaction',
              'socialNetwork': socialNetwork,
              'socialAction': 'Share',
              'socialTarget': socialTarget,
              'eventOrigin': 'front-end'
            });
          });
        });
      },

      /**
       * Toggle Social Share Bar event.
       */
      toggleSocialShareBar: function (context) {
        var $socialShareBlock = $('.block-social-sharing-block', context),
            $socialShareWrapper = $('.share-element-wrapper', $socialShareBlock),
            $socialShareButton = $('.share-icon', $socialShareBlock);

        $socialShareButton.on('click', () => {
          var eventAction = $socialShareWrapper.hasClass('active') ? 'Opened Social Bar' : 'User Closed Social Bar';

          datalayer.push({
            'event': 'Social Share',
            'eventCategory': 'Social Share',
            'eventAction': eventAction,
            'eventLabel': `Page URL: ${window.location.href}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end'
          });
        });
      },

      /**
       * Clicked a Story Pillar event.
       */
      clickedStoryPillar: function (context) {
        var $paragraphStoryPillars = $('.paragraph--type--story-pillars', context),
            $storyPillarsLink = $('a[href]', $paragraphStoryPillars);

        $storyPillarsLink.each(function () {
          var $this = $(this);

          $this.on('click', () => {
            var pillarTitle = $this.closest('.data-content').find('.story-title').text(),
                pillarEngagement = $this.hasClass('read-more') ? 'Read More Link' : 'Story Title';

            datalayer.push({
              'event': 'Story Pillar',
              'eventCategory': 'Story Pillar',
              'eventAction': 'Followed Link',
              'eventLabel': `Pillar Title: ${pillarTitle} | Area Engaged: ${pillarEngagement}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'pillarTitle': pillarTitle,
                'pillarEngagement': pillarEngagement
              }
            });
          });
        });
      },

      /**
       * Clicked Spotlight Paragraph event.
       */
      clickedSpotlightParagraph: function (context) {
        var $paragraphSpotlight = $('.spotlight', context),
            $spotlightLink = $('a[href]', $paragraphSpotlight);

        $spotlightLink.each(function () {
          var $this = $(this);

          $this.on('click', () => {
            var spotlightTitle = $this.closest('.spotlight--card__text').find('.field--name-field-headline').text(),
                spotlightEngagement = $this.parent().hasClass('read-more') ? 'Read More Link' : 'Headline';

            datalayer.push({
              'event': 'Spotlight',
              'eventCategory': 'Spotlight',
              'eventAction': 'Followed Link',
              'eventLabel': `Headline: ${spotlightTitle} | Area Engaged: ${spotlightEngagement}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'spotlightTitle': spotlightTitle,
                'spotlightEngagement': spotlightEngagement
              }
            });
          });
        });
      },

      /**
       * Clicked News Card event.
       */
      clickedNewsCard: function (context) {
        var $newsCard = $('.news-article-card', context),
            $newsCardTitleLink = $('.news-article-card__title a', $newsCard),
            $newsCardImageLink = $('.featured-image a', $newsCard),
            $newsCardMoreLink = $('a.read-more', $newsCard),
            $newsCardPDFLink = $('a.pdf', $newsCard);

        $newsCardTitleLink.each(function () {
          $(this).on('click', function () {
            pushNewsCardEvent($(this).text(), 'Card Title');
          });
        });

        $newsCardImageLink.each(function () {
          $(this).on('click', function () {
            pushNewsCardEvent(getNewsCardsTitle($(this)), 'Image');
          });
        });

        $newsCardMoreLink.each(function () {
          $(this).on('click', function () {
            pushNewsCardEvent(getNewsCardsTitle($(this)), 'Read More');
          });
        });

        $newsCardPDFLink.each(function () {
          $(this).on('click', function () {
            pushNewsCardEvent(getNewsCardsTitle($(this)), 'PDF');
          });
        });

        // Get title of News card where link was clicked.
        function getNewsCardsTitle($clickedLink) {
          return $clickedLink.closest('.news-article-card').find('.news-article-card__title').text().trim();
        }

        // Push Clicked News Card event.
        function pushNewsCardEvent(newsCardHeadline, newsCardEngagement) {
          datalayer.push({
            'event': 'News Card',
            'eventCategory': 'News Card',
            'eventAction': 'Followed Link',
            'eventLabel': `Headline: ${newsCardHeadline} | Area Engaged: ${newsCardEngagement}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end',
            'eventVars': {
              'newsCardHeadline': newsCardHeadline,
              'newsCardEngagement': newsCardEngagement
            }
          });
        }
      },

      /**
       * Clicked Property Card event.
       */
      clickedPropertyCard: function (context) {
        var $propertyCards = $('.property__cards', context),
            $propertyCardLink = $('a[href]', $propertyCards);

        $propertyCardLink.each(function () {
          var $this = $(this);

          $this.on('click', () => {
            var propertyTitle = $this.closest('.property-detail-tall-cards').find('.property-title').text().trim();

            switch ($this.parent().attr('class')) {
              case 'featured-image':
                var propertyEngagement = 'Image';
                break;

              case 'property-title':
                var propertyEngagement = 'Property Title';
                break;

              case 'cta--link':
                var propertyEngagement = 'CTA Link';
                break;

              default:
                break;
            }

            datalayer.push({
              'event': 'Property Card',
              'eventCategory': 'Property Card',
              'eventAction': 'Followed Link',
              'eventLabel': `Property Title: ${propertyTitle} | Area Engaged: ${propertyEngagement}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'propertyTitle': propertyTitle,
                'propertyEngagement': propertyEngagement
              }
            });
          });
        });
      },

      /**
       * Clicked Text and Image paragraph event.
       */
      clickedTextImageParagraph: function (context) {
        var $paragraphTextImage = $('.paragraph--type--text-and-image', context),
            $textImageLink = $('a[href]', $paragraphTextImage);

        $textImageLink.each(function () {
          var $this = $(this);

          $this.on('click', () => {
            var textAndImageTitle = $this.closest('.paragraph--type--text-and-image').find('.headline').text().trim(),
                textAndImageEngagement = $this.hasClass('read-more') ? 'Read More' : 'Headline';

            datalayer.push({
              'event': 'Text and Image Paragraph',
              'eventCategory': 'Text and Image Paragraph',
              'eventAction': 'Followed Link',
              'eventLabel': `Headline: ${textAndImageTitle} | Area Engaged: ${textAndImageEngagement}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'textAndImageTitle': textAndImageTitle,
                'textAndImageEngagement': textAndImageEngagement
              }
            });
          });
        });
      },

      /**
       * Clicked a Location Card event.
       */
      clickedLocationCard: function (context) {
        var $locationCards = $('.location-cards-collection', context),
            $locationCardLink = $('.card-column a[href]', $locationCards);

        $locationCardLink.each(function () {
          var $this = $(this);

          $this.on('click', () => {
            var locationTitle = $this.closest('.card-column').find('.title').text().trim(),
                locationEngagement = $this.hasClass('read-more') ? 'Read More' : 'Title';

            datalayer.push({
              'event': 'Location Card',
              'eventCategory': 'Location Card',
              'eventAction': 'Followed Link',
              'eventLabel': `Title: ${locationTitle} | Area Engaged: ${locationEngagement}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'locationTitle': locationTitle,
                'locationEngagement': locationEngagement
              }
            });
          });
        });
      },

      /**
       * Filtered News Cards event.
       */
      filteredNewsCards: function (context) {
        var $newsExposedForm = $('#views-exposed-form-news-articles-solr-page-1', context),
            $newsExposedFormSubmit = $('.form-submit', $newsExposedForm);

        $newsExposedFormSubmit.on('click', () => {
          var newsCardLocation = $('.form-item-field-location').find('.custom-select__current-option').text(),
              newsCardCategory = $('.form-item-field-content-category').find('.custom-select__current-option').text(),
              newsCardDates = $('.date-range-input').text();

          datalayer.push({
            'event': 'News Card',
            'eventCategory': 'News Card',
            'eventAction': 'Filtered Links',
            'eventLabel': `Location: ${newsCardLocation} | Category: ${newsCardCategory} | Date: ${newsCardDates}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end',
            'eventVars': {
              'newsCardLocation': newsCardLocation,
              'newsCardCategory': newsCardCategory,
              'newsCardDates': newsCardDates
            }
          });
        });
      },

      /**
       * Text Entered in Site Search Box event.
       */
      textEnteredInSearchBox: function (context) {
        var $overlaySearchForm = $('#views-exposed-form-acquia-search-block-search-overlay', context),
            $overlaySearchFormInput = $('input.form-autocomplete', $overlaySearchForm);

        var pushEventHandler = () => {
          var enteredText = $overlaySearchFormInput.val();

          datalayer.push({
            'event': 'Header Search',
            'eventCategory': 'Header Search',
            'eventAction': 'Entered Search Term',
            'eventLabel': `Term Searched: ${enteredText}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end',
            'eventVars': {
              'enteredText': enteredText
            }
          });
        };

        $overlaySearchFormInput.on('keyup', debounce(pushEventHandler, 1500));
      },

      /**
       * Followed Recommended Search Term on Search Overlay event.
       */
      followedRecommendedTermSearchOverlay: function (context) {
        var $searchForm = $("#views-exposed-form-acquia-search-block-search-overlay", context),
            $searchFormInput = $("input.form-autocomplete", $searchForm);

        $searchFormInput.bind('autocompleteselect', (event, ui) => {
          if (ui.item) {
            var followedTerm = ui.item.value
          }

          datalayer.push({
            'event': 'Header Search',
            'eventCategory': 'Header Search',
            'eventAction': 'Followed Recommended Search Term',
            'eventLabel': `Term Followed: ${followedTerm}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end',
            'eventVars': {
              'followedTerm': followedTerm
            }
          });
        });
      },

      /**
       * Engaged Button for Search Results on Search Overlay event.
       */
      engagedButtonSearchOverlay: function (context) {
        var $searchForm = $("#views-exposed-form-acquia-search-block-search-overlay", context),
            $searchFormSubmit = $(".form-submit", $searchForm);

        $searchFormSubmit.each(function () {
          $(this).on('click', function () {
            var buttonEngaged = $(this).val(),
                followedTerm = $('.form-autocomplete').val();

            datalayer.push({
              'event': 'Header Search',
              'eventCategory': 'Header Search',
              'eventAction': 'Engaged Button for Search Results',
              'eventLabel': `Button Text: ${buttonEngaged} | Term Followed: ${followedTerm}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end',
              'eventVars': {
                'buttonEngaged': buttonEngaged,
                'followedTerm': followedTerm
              }
            });
          });
        });
      },

      /**
       * Text Entered in Site Search Box event.
       */
      textEnteredInSearchPage: function (context) {
        var $overlaySearchForm = $("#views-exposed-form-acquia-search-page", context),
            $overlaySearchFormInput = $("input.form-autocomplete", $overlaySearchForm);

        var pushEventHandler = () => {
          var enteredText = $overlaySearchFormInput.val();

          datalayer.push({
            'event': 'Search Page',
            'eventCategory': 'Search Page',
            'eventAction': 'Entered Search Term',
            'eventLabel': `Term Searched: ${enteredText}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end',
            'eventVars': {
              'enteredText': enteredText
            }
          });
        };

        $overlaySearchFormInput.on('keyup', debounce(pushEventHandler, 1500));
      },

      /**
       * Followed Recommended Search Term on Search Page event.
       */
      followedRecommendedTermSearchPage: function (context) {
        var $searchForm = $("#views-exposed-form-acquia-search-page", context),
            $searchFormInput = $("input.form-autocomplete", $searchForm);

        $searchFormInput.on('autocompleteselect', (event, ui) => {
          if (ui.item) {
            var selectedSearchTerm = ui.item.value
          }

          datalayer.push({
            'event': 'Search Page Refresh',
            'eventCategory': 'Search Page',
            'eventAction': 'Followed Recommended Search Term',
            'eventLabel': `Term Followed: ${selectedSearchTerm}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end',
            'eventVars': {
              'selectedSearchTerm': selectedSearchTerm
            }
          });
        });
      },

      /**
       * Engaged Button for Search Results on Search Page event.
       */
      engagedButtonSearchResultsPage: function (context) {
        var $searchForm = $('#views-exposed-form-acquia-search-page', context);
        if (!$searchForm.length) {
          return;
        }

        var $searchFormSubmit = $('[id^="edit-submit"]', $searchForm);
        $searchFormSubmit.on('click', function (e) {
          // Skip triggered click events.
          if (e.isTrigger) {
            return;
          }

          var buttonEngaged = $(this).val();
          var searchKeyword = $('.form-autocomplete', $searchForm).val() ? $('.form-autocomplete', $searchForm).val() : 'Empty';
          var searchDateRange = $('.date-range-input', $searchForm).text();
          var searchSort = $('#edit-sort-bef-combine option:selected', $searchForm).text();

          datalayer.push({
            'event': 'Search Page Refresh',
            'eventCategory': 'Search Page',
            'eventAction': `Engaged ${buttonEngaged} Button for Search Results`,
            'eventLabel': `Keywords: ${searchKeyword} | Date Range: ${searchDateRange} | Sort by ${searchSort}`,
            'eventValue': 'front-end',
            'eventVars': {
              'buttonUsed': buttonEngaged,
              'searchKeyword': searchKeyword,
              'searchDateRange': searchDateRange,
              'searchSort': searchSort
            }
          });
        });
      },

      /**
       * Zero Results on Search Page event.
       */
      zeroResultsSearchResultsPage: function (context) {
        var $searchResultsWrapper = $('.search-results-wrapper', context);
        var $resultOutput = $('.result-output', $searchResultsWrapper);
        var $searchTermField = $('#views-exposed-form-acquia-search-page input.form-autocomplete', context);

        if ($searchResultsWrapper.length) {
          if ($resultOutput.length) {
            return;
          }
          var searchTerm = $searchTermField.val();
          datalayer.push({
            'event': 'Search Page',
            'eventCategory': 'Search Page',
            'eventAction': 'Received Zero Results',
            'eventLabel': `Search Term: ${searchTerm}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end',
            'eventVars': {
              'searchTerm': searchTerm
            }
          });
        }
      },

      /**
       * Property Explorer Applied Filter event.
       */
      propertyExplorerAppliedFilter: function (context) {
        var checkedLocations = [];
        var checkedTypes = [];
        var propertyLocation = 'ul[data-drupal-facet-id$=_location]';
        var propertyType = 'ul[data-drupal-facet-id$=property_type]';
        var $propertyFilterCheckbox = $('input[type=checkbox]', `${propertyLocation}, ${propertyType}`);

        if (!$propertyFilterCheckbox.length) {
          return;
        }

        $(once('property_filter', $propertyFilterCheckbox)).on('click', () => {
          $(once('ajax_stop', 'html')).ajaxStop(() => {
            checkedLocations = $('input[type=checkbox]:checked', propertyLocation).map(function () {
              return $(this).next('label').find('.facet-item__value').text();
            }).get();

            checkedTypes = $('input[type=checkbox]:checked', propertyType).map(function () {
              return $(this).next('label').find('.facet-item__value').text();
            }).get();

            pushAppliedFilterEvent(getItemsString(checkedLocations), getItemsString(checkedTypes));
          });
        });

        // Prepare list of clicked items as comma separated string.
        function getItemsString(checkedItems) {
          if (checkedItems.length) {
            return checkedItems.join(', ');
          }
          else {
            return 'all';
          }
        }

        function pushAppliedFilterEvent(checkedLocations, checkedTypes) {
          datalayer.push({
            'event': 'Property Explorer',
            'eventCategory': 'Property Explorer',
            'eventAction': 'Applied Filter',
            'eventLabel': `Labels > Property Location: ${checkedLocations} | Property Type: ${checkedTypes}`,
            'eventValue': undefined,
            'eventOrigin': 'front-end'
          });
        }
      },

      /**
       * Property Explorer Show More/Less Selected event.
       */
      propertyExplorerShowMoreLess: function (context) {
        var selectedLimit = '';
        var category = '';
        var $propertyLocation = $('[id^=block-propertylocation]');
        var $propertyType = $('[id^=block-propertytype]');

        if (!$propertyLocation.length || !$propertyType.length) {
          return;
        }

        $(document).ready(() => {
          var $facetsLimitLink = $('.facets-soft-limit-link', context);

          $(once('facets_soft_limit', $facetsLimitLink)).on('click', (e) => {
            var $target = $(e.target);

            if ($target.hasClass('open')) {
              selectedLimit = 'Show More';
            }
            else {
              selectedLimit = 'Show Less';
            }

            if ($propertyLocation.has($target).length) {
              category = 'Property Location';
            }
            if ($propertyType.has($target).length) {
              category = 'Property Type';
            }

            datalayer.push({
              'event': 'Property Explorer',
              'eventCategory': 'Property Explorer',
              'eventAction': `Selected ${selectedLimit}`,
              'eventLabel': `Filter: ${category}`,
              'eventValue': undefined,
              'eventOrigin': 'front-end'
            });
          });
        });
      }
    }
  };
})(jQuery, window.Drupal, window.dataLayer, Drupal.debounce, once);
